import React from "react";

import TableWrapper from "../../shared/bootstrap/TableWrapper.jsx";

import { formatPlural } from "../../../util/format.js";

/**
 * TopInfoBar Component
 * @param {Object} props
 * @param {number} props.ordersCount
 * @param {{firstName: string, lastName: string}} props.user
 * @param {number} props.displayCount
 * @param {function} props.changeDisplay
 * @param {number} props.currentPageCount
 * @returns {React.JSX.Element}
 */
export default function TopInfoBar({ ordersCount, user, displayCount, changeDisplay, currentPageCount }) {
  const orderCountMessage =
    `(${ordersCount}) ${formatPlural("order", ordersCount)} found` +
    (user.firstName === "" && user.lastName === "" ? "" : ` for ${user.firstName} ${user.lastName}`);

  return (
    <TableWrapper>
      <tbody>
        <tr>
          <th className="col-xs-4 no-border">{orderCountMessage}</th>
          <th className="col-xs-4 text-center no-border" data-ng-if="orderCtl.totalRows>10">
            Displaying {currentPageCount} of {ordersCount} {formatPlural("order", ordersCount)}
          </th>
          <th className={`col-xs-${ordersCount === displayCount ? "6" : "4"} no-border float-right`}>
            <a className="clickable-link" onClick={changeDisplay} href="javascript:;">
              {ordersCount === displayCount ? "View 10 Orders per page" : "View All Orders"}
            </a>
          </th>
        </tr>
      </tbody>
    </TableWrapper>
  );
}
